import { View, Text } from '@react-pdf/renderer';

import type { PdfStylesType } from '@/_shared';
import { PdfHeader, PdfPage, basePdfStyles } from '@/_shared';

type AuditTrailTemplateProps = {
  generationDate: string;
  email: string;
  phone: string;
  signeeIpAddress: string;
  tncSignedBy: string;
  tncPage1SignedAt: string;
  tncPage2SignedAt: string;
  tncPage3SignedAt: string;
  tncPage4SignedAt: string;
};

export function AuditTrailTemplate({
  generationDate,
  email,
  phone,
  signeeIpAddress,
  tncSignedBy,
  tncPage1SignedAt,
  tncPage2SignedAt,
  tncPage3SignedAt,
  tncPage4SignedAt,
}: AuditTrailTemplateProps) {
  const { grow, rowView, mt2, mb2, secondaryColor, xxlFont, serif, boldFont, columnView, orangeColor } = basePdfStyles;

  return (
    <PdfPage>
      <PdfHeader />
      <View style={[grow]}>
        <View style={[rowView, mt2, mb2]}>
          <Text style={[secondaryColor, xxlFont, serif, orangeColor, boldFont]}>Audit Trail</Text>
        </View>

        <View style={[columnView, mt2]}>
          <Row label="Generated On" value={generationDate} styles={basePdfStyles} first />
          <Row label="T&C Signed By" value={tncSignedBy} styles={basePdfStyles} />
          <Row label="Customer Email" value={email} styles={basePdfStyles} />
          <Row label="Customer Phone" value={phone} styles={basePdfStyles} />
          <Row label="Signee IP Address" value={signeeIpAddress} styles={basePdfStyles} />
          <Row label="T&C Page 1 Signed On" value={tncPage1SignedAt} styles={basePdfStyles} />
          <Row label="T&C Page 2 Signed On" value={tncPage2SignedAt} styles={basePdfStyles} />
          <Row label="T&C Page 3 Signed On" value={tncPage3SignedAt} styles={basePdfStyles} />
          <Row label="T&C Page 4 Signed On" value={tncPage4SignedAt} styles={basePdfStyles} />
        </View>
      </View>
    </PdfPage>
  );
}

function Row({
  label,
  value,
  styles: _styles,
  first = false,
}: {
  label?: string;
  value?: string;
  styles: PdfStylesType;
  first?: boolean;
}) {
  const { borderBottom, rowView, justifySpaceBetween, baseFont, sans, secondaryColor, textRight, mt2, capitalize } =
    _styles;
  return (
    <View style={[borderBottom, rowView, justifySpaceBetween, first ? {} : mt2]}>
      <Text style={[sans, baseFont, secondaryColor]}>{label}</Text>
      <Text style={[capitalize, sans, baseFont, secondaryColor, textRight]}>{value}</Text>
    </View>
  );
}
